import ProductTicket from './ProductTicket';
import { ProductTicketNGSResponse } from '../types';

class ProductTicketNGS extends ProductTicket {
  ticket: ProductTicketNGSResponse;

  constructor(ticket: ProductTicketNGSResponse) {
    super(ticket);
    this.ticket = ticket;
  }

  getBetshopUuid() {
    return this.ticket.betshopId;
  }
}

export default ProductTicketNGS;
